import React from 'react';
import './card-sec3.css'

const Cardsec3 = (props) => {
    return ( 
        <article className='card-sec3'>
            <figure className='container-img-sec3'>
                <img className='imgg-sec3' src={props.imgg} alt='pic'></img>
            </figure>
            <h2 className='title-card-sec3'>{props.title}</h2>
            <p className='para-card-sec3'>{props.para}</p>
        </article>
     );
}
 
export default Cardsec3;